import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

type UserPageParams = {
  userId: string;
  accountId?: string;
  workspaceId?: string;
  objectSlug?: string;
};

/**
 * Context used by the contact drawer to provide route-like params
 * without a nested Router.
 */
export const UserPageParamsContext = createContext<UserPageParams | null>(null);

/**
 * Drop-in replacement for useParams() in user/contact page components.
 * Checks the drawer context first, falls back to react-router useParams().
 */
const useUserPageParams = () => {
  const ctx = useContext(UserPageParamsContext);
  const params = useParams<Record<string, string>>();

  if (ctx) {
    return {
      ...params,
      userId: ctx.userId,
      accountId: ctx.accountId || params.accountId,
      workspaceId: ctx.workspaceId || params.workspaceId,
      objectSlug: ctx.objectSlug || params.objectSlug,
    };
  }

  return params;
};

export default useUserPageParams;
